import { DataField, Divider, IconButton, Space, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type Vendor } from '@webapp/models'
import { VendorTypes } from '@webapp/models/enums/Vendor'
import messages from './messages'
import { VendorSettingsStyled } from './styles/VendorSettingsStyled'

export interface IVendorSettingsProps {
  vendor: Vendor
  onEdit?: () => void
}

export const VendorSettings = ({ vendor, onEdit }: IVendorSettingsProps) => {
  const intl = useProcurifyIntl()

  const isPreferredVendor =
    vendor.type === VendorTypes.PREFERRED
      ? intl.formatMessage(messages.yesText)
      : intl.formatMessage(messages.noText)

  return (
    <VendorSettingsStyled>
      <Space direction='horizontal' align='stretch'>
        <Space.Item width={2 / 5}>
          <Space>
            <DataField label={intl.formatMessage(messages.paymentTermsLabel)}>
              {vendor.payment_term_ref?.name || '--'}
            </DataField>
            <DataField
              label={intl.formatMessage(messages.shippingMethodsLabel)}
            >
              {vendor.shipping_method_ref?.name || '--'}
            </DataField>
          </Space>
        </Space.Item>
        <Space.Item width={2 / 5}>
          <Space>
            <DataField label={intl.formatMessage(messages.shippingTermsLabel)}>
              {vendor.shipping_term_ref?.name || '--'}
            </DataField>
            <DataField
              label={intl.formatMessage(messages.pdfLabelSetLabel)}
              labelIcon='question'
              labelTooltipAriaLabel={intl.formatMessage(
                messages.pdfLabelSetTooltipAriaLabel
              )}
              labelTooltipMessage={intl.formatMessage(
                messages.pdfLabelSetTooltipMessage
              )}
            >
              {vendor.po_pdf_labels || '--'}
            </DataField>
          </Space>
        </Space.Item>
        {!!onEdit && (
          <Space.Item width={1 / 5}>
            <Space align='end'>
              <IconButton
                aria-label={intl.formatMessage(messages.editSettingsLabel)}
                icon='edit'
                onClick={onEdit}
              />
            </Space>
          </Space.Item>
        )}
      </Space>
      <Divider />
      <Space direction='horizontal' align='stretch'>
        <Space.Item width={2 / 5}>
          <DataField
            label={intl.formatMessage(messages.poEmailAutomationLabel)}
            labelIcon='question'
            labelTooltipAriaLabel={intl.formatMessage(
              messages.poEmailAutomationTooltipAriaLabel
            )}
            labelTooltipMessage={intl.formatMessage(
              messages.poEmailAutomationTooltipMessage
            )}
          >
            {vendor.is_auto_email_po_enabled
              ? intl.formatMessage(messages.yesText)
              : intl.formatMessage(messages.noText)}
          </DataField>
        </Space.Item>
        <Space.Item width={2 / 5}>
          <DataField label={intl.formatMessage(messages.emailRecipientsLabel)}>
            {vendor?.email?.map((email, index) => (
              <Text key={`${email}-${index}`}>{email}</Text>
            )) || '--'}
          </DataField>
        </Space.Item>
      </Space>
      <Divider />
      <Space direction='horizontal' align='stretch'>
        <DataField label={intl.formatMessage(messages.preferredVendorLabel)}>
          {isPreferredVendor}
        </DataField>
      </Space>
    </VendorSettingsStyled>
  )
}
